if (!customElements.get('product-flower')) {
  customElements.define('product-flower', class ProductFlower extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-flower-variants]')?.textContent || '[]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.price = this.querySelector('[data-flower-price]');
      this.submit = this.querySelector('[data-submit-button]');
      this.submitText = this.querySelector('[data-submit-text]');
      this.quantity = this.querySelector('[data-quantity-input]');
      this.mainImage = this.querySelector('.flower-gallery__image');
      this.moneyFormat = this.dataset.moneyFormat || '€{{ amount_with_comma_separator }}';

      this.bindOptions();
      this.bindQuantity();
      this.bindMessage();
      this.bindDelivery();
      this.bindGallery();
      this.updateOptionAvailability();
    }

    bindOptions() {
      this.querySelectorAll('.flower-option__card').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          const group = button.closest('.flower-option');
          group.querySelectorAll('.flower-option__card').forEach((item) => item.classList.remove('is-selected'));
          button.classList.add('is-selected');
          this.updateVariant();
          this.updateOptionAvailability();
        });
      });
    }

    bindQuantity() {
      this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        this.quantity.value = Math.max(1, Number(this.quantity.value || 1) - 1);
      });

      this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        this.quantity.value = Number(this.quantity.value || 1) + 1;
      });
    }

    bindMessage() {
      const input = this.querySelector('[data-message-input]');
      const count = this.querySelector('[data-message-count]');
      input?.addEventListener('input', () => {
        count.textContent = input.value.length;
      });
    }

    bindDelivery() {
      this.querySelectorAll('.flower-delivery__card').forEach((card) => {
        card.addEventListener('click', () => {
          this.querySelectorAll('.flower-delivery__card').forEach((item) => item.classList.remove('is-selected'));
          card.classList.add('is-selected');
        });
      });
    }

    bindGallery() {
      const thumbs = Array.from(this.querySelectorAll('.flower-gallery__thumb'));
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.selectThumb(thumb)));

      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
        const index = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
        this.selectThumb(thumbs[(index - 1 + thumbs.length) % thumbs.length]);
      });

      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
        const index = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
        this.selectThumb(thumbs[(index + 1) % thumbs.length]);
      });
    }

    selectThumb(thumb) {
      if (!thumb || !this.mainImage) return;
      this.querySelectorAll('.flower-gallery__thumb').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      this.mainImage.src = thumb.dataset.full;
      this.mainImage.removeAttribute('srcset');
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('.flower-option')).map((group) => {
        return group.querySelector('.flower-option__card.is-selected')?.dataset.optionValue;
      });
    }

    updateVariant() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((item) => item.options.every((option, index) => option === selected[index]));

      if (!variant) {
        this.setUnavailable();
        return;
      }

      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
      this.price.textContent = this.formatMoney(variant.price);
      this.submit.disabled = !variant.available;
      this.submit.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      this.submitText.textContent = variant.available ? 'AJOUTER AU PANIER' : 'INDISPONIBLE';

      if (variant.featured_media_id) {
        this.selectThumb(this.querySelector(`[data-media-id="${variant.featured_media_id}"]`));
      }
    }

    updateOptionAvailability() {
      const selected = this.selectedOptions();
      this.querySelectorAll('.flower-option__card').forEach((button) => {
        const index = Number(button.dataset.optionPosition) - 1;
        const candidate = [...selected];
        candidate[index] = button.dataset.optionValue;
        const available = this.variants.some((variant) => {
          return variant.available && variant.options.every((option, optionIndex) => {
            return !candidate[optionIndex] || candidate[optionIndex] === option;
          });
        });

        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
      });
    }

    setUnavailable() {
      this.submit.disabled = true;
      this.submit.setAttribute('aria-disabled', 'true');
      this.submitText.textContent = 'INDISPONIBLE';
    }

    formatMoney(cents) {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      const comma = amount.replace('.', ',');
      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
  });
}
